import OncadeSDK from './index';
import * as OncadeNamedExports from './index';
import { 
  SDKConfig, 
  PurchaseItem, 
  PurchaseURLOptions, 
  LoginURLOptions, 
  Transaction, 
  PurchaseCatalog,
  ApiResponse
} from './types';

// Re-export everything from the main entry point for named imports
export * from './index';

// Export the SDK as the default export
// Use both export default and module.exports for maximum compatibility
export default OncadeSDK;

// Explicitly export types to make them accessible from the browser bundle
export {
  SDKConfig, 
  PurchaseItem, 
  PurchaseURLOptions, 
  LoginURLOptions, 
  Transaction,
  PurchaseCatalog,
  ApiResponse
};

// Also attach to window for direct browser usage
if (typeof window !== 'undefined') {
  // Attach as OncadeSDK
  (window as any).OncadeSDK = OncadeSDK;
  
  // Also expose all named exports on the window.OncadeSDK object
  Object.entries(OncadeNamedExports).forEach(([key, value]) => {
    if (key !== 'default') {
      (window as any).OncadeSDK[key] = value;
    }
  });
  
  // Explicitly attach type interfaces to the window.OncadeSDK object
  // This makes types available for type checking and documentation
  (window as any).OncadeSDK.SDKConfig = true;
  (window as any).OncadeSDK.PurchaseItem = true;
  (window as any).OncadeSDK.PurchaseURLOptions = true;
  (window as any).OncadeSDK.LoginURLOptions = true;
  (window as any).OncadeSDK.Transaction = true;
  (window as any).OncadeSDK.PurchaseCatalog = true;
  (window as any).OncadeSDK.ApiResponse = true;
  
  // Add a helper to check if localStorage is available
  const isLocalStorageAvailable = (): boolean => {
    try {
      const testKey = '__oncade_test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      console.warn('localStorage is not available in this environment');
      return false;
    }
  };
  
  // Add localStorage availability to window for SDK to check
  (window as any).__oncadeLocalStorageAvailable = isLocalStorageAvailable();
} 